import React from 'react';
import { CheckCircle2, Users, School, Award } from 'lucide-react';
export const WhyNisaWorks = () => {
  const stats = [{
    icon: <Users className="w-6 h-6" data-id="element-471" />,
    value: '94%',
    label: 'of coaches report reduced administrative workload',
    gradient: 'from-primary-500 to-primary-600'
  }, {
    icon: <School className="w-6 h-6" data-id="element-472" />,
    value: '2.5x',
    label: 'more time spent directly supporting teachers',
    gradient: 'from-purple-600 to-pink-600'
  }, {
    icon: <Award className="w-6 h-6" data-id="element-473" />,
    value: '87%',
    label: 'of teachers report more personalized support',
    gradient: 'from-pink-600 to-orange-600'
  }];
  return <section id="why-nisa-works" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-474">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-475">
        <div className="grid md:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-476">
          <div className="md:col-span-8 lg:col-span-7" data-id="element-477">
            <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 mb-4 leading-tight" data-id="element-478">
              Built on research.
              <br data-id="element-479" />
              Designed with coaches.
            </h2>
            <div className="space-y-8 md:space-y-10" data-id="element-480">
              <p className="text-xl text-cyan-900" data-id="element-481">
                Nisa supports meaningful relationships and evidence-based
                instruction.
              </p>
              <div className="space-y-6 text-gray-600" data-id="element-482">
                <p data-id="element-483">
                  We believe coaching should feel human. Nisa is designed to
                  model instructional best practices. Instead of simply
                  automating tasks, we provide research-aligned scaffolds
                  grounded in the real world of coaching.
                </p>
                <p data-id="element-484">
                  The system is powered by a deep partnership with{' '}
                  <a href="https://teachinglab.org/" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200" data-id="element-485">
                    Teaching Lab's team
                  </a>{' '}
                  of instructional experts, drawing on a proven coaching theory
                  of action used in districts across the country.
                </p>
              </div>
            </div>
          </div>
          <div className="md:col-span-4 lg:col-span-5 space-y-8 lg:flex lg:flex-col lg:justify-end" data-id="element-486">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100" data-id="element-487">
              <div className="space-y-6" data-id="element-488">
                {['Research-backed coaching frameworks', 'Evidence-based instructional strategies', 'Personalized teacher support pathways'].map((point, index) => <div key={index} className="flex items-center gap-4 group" data-id="element-489">
                    <div className="flex-shrink-0 transform transition-transform duration-300 group-hover:scale-110" data-id="element-490">
                      <CheckCircle2 className="w-7 h-7 text-primary-600" data-id="element-491" />
                    </div>
                    <span className="text-lg text-gray-800 font-medium" data-id="element-492">
                      {point}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};